const autocompleteContacts = async (query = 't') => {
    const {
        data: { data: contacts },
    } = await ApiClient.get('/search', {
        q: query,
        type: ['contact', 'company'],
        limit: 5,
    });
    //TODO changer retour https://sellsy.atlassian.net/browse/SAAS-22465
    return contacts.map((contact) => {
        return {
            firstName: _.capitalize(contact.first_name),
            lastName: _.capitalize(contact.last_name),
            email: contact.email,
            id: contact?.object?.id,
            type: contact?.object?.type,
        };
    });
};

const getEmailThreadById = (threadId) => {
    const error = window.i18n.__(
        'Un problème est survenu lors de la recherche. Veuillez réessayer plus tard.',
    );
    return new Promise((resolve, reject) => {
        if (threadId) {
            ApiClient.get(`/emails/threads/${threadId}`)
                .then((res) => {
                    resolve(res.data);
                })
                .catch(() => {
                    reject(error);
                });
        } else {
            reject(error);
        }
    });
};

const sendEmail = (params) => {
    const error = window.i18n.__(
        "Un problème est survenu lors de l'envoi. Veuillez réessayer plus tard.",
    );
    return new Promise((resolve, reject) => {
        if (params) {
            ApiClient.post('/email/send', {}, { ...params })
                .then((res) => {
                    resolve(res.data);
                })
                .catch(() => {
                    reject(error);
                });
        } else {
            reject(error);
        }
    });
};

const getEmailSettings = () => {
    const error = window.i18n.__('Un problème est survenu. Veuillez réessayer plus tard.');
    return new Promise((resolve, reject) => {
        ApiClient.get('/settings/email')
            .then((res) => {
                resolve(res);
            })
            .catch(() => {
                reject(error);
            });
    });
};

const setEmailSettings = (params) => {
    return new Promise((resolve, reject) => {
        ApiClient.put(`/settings/email`, {}, { ...params })
            .then((res) => {
                resolve(res.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

const getPrefillInfo = (id, type) => {
    const error = window.i18n.__(
        "Un problème est survenu pour pré-renseigner l'email. Veuillez réessayer plus tard.",
    );
    return new Promise((resolve, reject) => {
        ApiClient.get(`/email/recipient-suggestion/${type}/${id}`)
            .then((res) => {
                resolve(res);
            })
            .catch(() => {
                reject(error);
            });
    });
};

const getRecomendUsers = (id, type) => {
    const error = window.i18n.__(
        'Un problème est survenu pour récupérer la liste des utilisateurs recommandés. Veuillez réessayer plus tard.',
    );
    return new Promise((resolve, reject) => {
        ApiClient.get(`/email/recipients/${type}/${id}`)
            .then((res) => {
                resolve(res);
            })
            .catch(() => {
                reject(error);
            });
    });
};

const getListEmailTemplates = () => {
    const error = window.i18n.__(
        'Un problème est survenu pour récupérer la liste des modèles. Veuillez réessayer plus tard.',
    );
    return new Promise((resolve, reject) => {
        ApiClient.get('/email/templates')
            .then((res) => {
                resolve(res);
            })
            .catch(() => {
                reject(error);
            });
    });
};

const getEmailTemplateWithContent = (id, params) => {
    const error = window.i18n.__(
        'Un problème est survenu pour récupérer les informations du modèle. Veuillez réessayer plus tard.',
    );
    return new Promise((resolve, reject) => {
        ApiClient.post(`/email/templates/${id}`, {}, { ...params })
            .then((res) => {
                resolve(res.data);
            })
            .catch(() => {
                reject(error);
            });
    });
};

const getEmailTemplateTags = () => {
    const error = window.i18n.__(
        'Un problème est survenu pour récupérer les tags des modèles. Veuillez réessayer plus tard.',
    );
    return new Promise((resolve, reject) => {
        ApiClient.get('/email/templates/tags')
            .then((res) => {
                resolve(res);
            })
            .catch(() => {
                reject(error);
            });
    });
};

const getEmailTemplate = (id) => {
    const error = window.i18n.__(
        'Un problème est survenu pour récupérer les informations du modèle. Veuillez réessayer plus tard.',
    );
    return new Promise((resolve, reject) => {
        if (id) {
            ApiClient.get(`/email/templates/${id}`)
                .then((res) => {
                    resolve(res.data);
                })
                .catch(() => {
                    reject(error);
                });
        } else {
            reject(error);
        }
    });
};

const deleteEmailTemplate = (id) => {
    const error = window.i18n.__(
        'Un problème est survenu pour supprimer le modèle. Veuillez réessayer plus tard.',
    );
    return new Promise((resolve, reject) => {
        if (id) {
            ApiClient.del(`/email/templates/${id}`)
                .then((res) => {
                    resolve(res);
                })
                .catch(() => {
                    reject(error);
                });
        } else {
            reject(error);
        }
    });
};

const createEmailTemplate = (params) => {
    const error = window.i18n.__(
        'Un problème est survenu pour créer le modèle. Veuillez réessayer plus tard.',
    );
    return new Promise((resolve, reject) => {
        if (params) {
            ApiClient.post('/email/templates', {}, { ...params })
                .then((res) => {
                    resolve(res.data);
                })
                .catch(() => {
                    reject(error);
                });
        } else {
            reject(error);
        }
    });
};

const editEmailTemplate = (id, params) => {
    const error = window.i18n.__(
        'Un problème est survenu pour modifier le modèle. Veuillez réessayer plus tard.',
    );
    return new Promise((resolve, reject) => {
        if (id && params) {
            ApiClient.put(`/email/templates/${id}`, {}, { ...params })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((error) => {
                    reject(error);
                });
        } else {
            reject(error);
        }
    });
};

const getMandateTemplate = (data) => {
    return ApiClient.post('/email/system-templates/gocardless_mandate_request', {}, { ...data });
};

const getSystemEmailTemplate = (context, data) => {
    return ApiClient.post(`/email/system-templates/${context}`, {}, { ...data });
};

const getFilteredEmails = (statusArray) => {
    const error = window.i18n.__(
        'Un problème est survenu lors de la récupération des emails. Veuillez réessayer plus tard.',
    );

    return new Promise((resolve, reject) => {
        if (statusArray && statusArray.length > 0) {
            ApiClient.post('/emails/search', {}, { ...{ filters: { status: statusArray } } })
                .then((res) => {
                    resolve(res.data);
                })
                .catch(() => {
                    reject(error);
                });
        } else {
            reject(error);
        }
    });
};

const deleteEmailById = (id) => {
    const error = window.i18n.__(
        "Un problème est survenu lors de la suppression de l'email. Veuillez réessayer plus tard.",
    );

    return new Promise((resolve, reject) => {
        if (id) {
            ApiClient.del(`/emails/${id}`)
                .then((res) => {
                    resolve(res);
                })
                .catch(() => {
                    reject(error);
                });
        } else {
            reject(error);
        }
    });
};

const resendFailedEmailById = (id) => {
    const error = window.i18n.__(
        "Un problème est survenu après avoir renvoyer l'email. Veuillez réessayer plus tard.",
    );

    return new Promise((resolve, reject) => {
        if (id) {
            ApiClient.post(`/emails/${id}/resend`)
                .then((res) => {
                    resolve(res);
                })
                .catch(() => {
                    reject(error);
                });
        } else {
            reject(error);
        }
    });
};

const rensendAllFailedEmails = () => {
    const error = window.i18n.__(
        'Un problème est survenu après avoir renvoyer tous les emails. Veuillez réessayer plus tard.',
    );

    return new Promise((resolve, reject) => {
        ApiClient.post('/emails/resend-failed')
            .then((res) => {
                resolve(res);
            })
            .catch(() => {
                reject(error);
            });
    });
};

const searchProviderThreads = (filters, queryParams) => {
    return new Promise((resolve, reject) => {
        ApiClient.post('/emails/provider/threads/search', queryParams, { filters: filters })
            .then((res) => {
                resolve(res.data);
            })
            .catch((error) => {
                let errorMessage = window.sellsyapp.$t.__('email.listings.error_loading_emails');
                switch (error?.response?.status) {
                    case 409:
                        errorMessage = window.sellsyapp.$t.__(
                            'email.listings.error_sync_in_progress',
                        );
                        break;
                    default:
                        break;
                }
                reject(errorMessage);
            });
    });
};

const updateProviderThread = (updateProviderThreadLink, data) => {
    return new Promise((resolve, reject) => {
        ApiClient.patch(updateProviderThreadLink, {}, data)
            .then((res) => {
                resolve(res.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

const getProviderThreadMessages = (readProviderThreadLink) => {
    return new Promise((resolve, reject) => {
        ApiClient.get(readProviderThreadLink)
            .then((res) => {
                resolve(res.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

const updateProviderThreadMessagesRelatedBatch = (
    updateProviderThreadMessagesRelatedBatchLink,
    data,
) => {
    return new Promise((resolve, reject) => {
        ApiClient.put(updateProviderThreadMessagesRelatedBatchLink, {}, data)
            .then((res) => {
                resolve(res.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export {
    autocompleteContacts,
    getEmailThreadById,
    sendEmail,
    getEmailSettings,
    getPrefillInfo,
    getRecomendUsers,
    getListEmailTemplates,
    getEmailTemplateWithContent,
    getEmailTemplateTags,
    getEmailTemplate,
    deleteEmailTemplate,
    createEmailTemplate,
    editEmailTemplate,
    getMandateTemplate,
    getSystemEmailTemplate,
    setEmailSettings,
    getFilteredEmails,
    deleteEmailById,
    resendFailedEmailById,
    rensendAllFailedEmails,
    searchProviderThreads,
    updateProviderThread,
    getProviderThreadMessages,
    updateProviderThreadMessagesRelatedBatch,
};
